import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

export const useURLPagination = (
  paginationParams: Record<string, [any, Function]>
) => {
  const history = useHistory();
  const location = useLocation();

  const deps = Object.values(paginationParams).map((v) => v[0]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    for (let [k, [_, setter]] of Object.entries(paginationParams)) {
      if (k === "page") {
        const val = params.get(k);
        if (val) {
          setter(val);
        }
      }
    }
  }, [location]);

  useEffect(() => {
    const params = new URLSearchParams(history.location.search);

    for (let [k, [getter, _]] of Object.entries(paginationParams)) {
      const val = params.get(k);
      if (getter) {
        params.set(k, getter.toString());
        if (!val) {
          history.replace({
            pathname: "",
            search: params.toString(),
          });
        } else {
          if (val)
            /* replaces url text */
            history.push({
              pathname: "",
              // search: params.toString(),
              search:
                params.get("page") === "1"
                  ? localStorage.getItem("paginationString") ||
                    "page=1&filterPageNo=1"
                  : params.toString(),
            });
          return;
        }
      }
    }
  }, [history, ...deps]);
};
